export default __webpack_public_path__ + "static/media/center3.d1c6c7f5.jpg";